import ApolloClient,  { InMemoryCache } from 'apollo-boost';
import { AUTH_TOKEN } from './helper/constants';
import { toast } from "react-toastify";

/// oneoone.assets
let uri = "http://architects-aaa6c.appspot.com/graphql";
if( process.env.REACT_APP_NODE_ENV === "local" ) {
  uri = "http://localhost:4000/graphql";
} else if( process.env.REACT_APP_NODE_ENV === "development" ) {
  uri = "https://dev-101-architects-5467b.uc.r.appspot.com/graphql";
}
console.log(uri);


const client = new ApolloClient({
    uri: uri,
    onError: ({ graphQLErrors, networkError }) => {
      if( graphQLErrors ) {
        console.log(graphQLErrors);
        graphQLErrors.map(({ extensions, message, locations, path }) => {
          if( extensions && extensions.code === "UNAUTHENTICATED" ) {
            toast.error(message);
          }
          
          console.log(
            `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`,
          );
        });
      }

      if( networkError ) {
        toast.error(`Network error: ${networkError}`);
        console.log(`[Network error]: ${networkError}`)
      }

    },

    cache: new InMemoryCache({
      dataIdFromObject: object => object.id || null
    }),
});

export default client;
